import React, { useState } from 'react';
import { ButtonComponent } from '../ButtonComponent';
import { executeRecaptcha } from '../../views/login/Login';
import axios from 'axios';
import { BASE_URL } from '../../../config/environmentConfig';
import toastMessage from '../ToastMessage';
import { toaster } from 'rsuite';

interface Props {
	setIsSubmitted: (value: boolean) => void;
}

export const CustomerForm = (props: Props): React.ReactElement => {
	const { setIsSubmitted } = props;
	const [showError, setShowError] = useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(false);
	const [orderId, setOrderId] = useState<string>('');

	const handleSubmit = async (e): Promise<void> => {
		e.preventDefault();
		if (!orderId) {
			return setShowError(true);
		}
		setLoading(true);
		setShowError(false);
		const recaptchaToken = await executeRecaptcha();
		const params = {
			token: recaptchaToken,
			confirmationId: orderId
		};
		try {
			await axios.post(`${BASE_URL.ORDERS}/orders/send-info`, params);
			setIsSubmitted(true);
			setLoading(false);

		} catch (e) {
			console.log('e', e);
			setLoading(false);
			toaster.push(toastMessage({
				text: 'Invalid signup request. Click on "Get Help" to send us your issue.',
				type: 'error',
				closable: true
			}), { placement: 'topEnd', duration: 0 });
		}

	};

	const handleChange = (e): void => {
		setOrderId(e.target.value);
		if (showError) {
			setShowError(false);
		}
	};
	return (
		<form className="mt-10 form w-100" onSubmit={handleSubmit}>
			<div className="field-container">
				<input
					placeholder="Insert order id here"
					className="form-control form-control-lg form-control-solid"
					value={orderId}
					onChange={handleChange}
				/>
				{showError && <div className="error-container text-danger">Order id is required</div>}
			</div>
			<ButtonComponent
				buttonName="Submit"
				type="submit"
				additionalClass="mt-5 w-200px mx-auto"
				loading={loading}
				isDisabled={loading}
			/>
		</form>
	);
};
